<template>
  <article class="mobile-wrap">
    <section class="content">
      <section class="page page2">
        <div class="form-box">
          <ul class="os-box flex justify-between">
            <li class="flex justify-between items-center" @click="formData.os = 'android'">
              <span :class="`os${formData.os === 'android' ? ' active' : ''}`"></span>
              <p class="gp"></p>
            </li>
            <li class="flex justify-between items-center" @click="formData.os = 'ios'">
              <span :class="`os${formData.os === 'ios' ? ' active' : ''}`"></span>
              <p class="app"></p>
            </li>
          </ul>
          <div class="input-box">
            <span>010</span>
            <input v-model="formData.phone" type="text" class="input-txt" placeholder="-을 제외한 숫자만 입력해 주세요." @input="handleInput" minlength="7" maxlength="8">
          </div>
          <p class="check-box">
            <a @click="hasChecked = !hasChecked" href="javascript:;" :class="`check${hasChecked ? ' active' : ''}`"></a><span @click="showDialog.privacy = true" class="txt">개인정보 수집 및 이용
              동의/SMS 수신 동의</span>
          </p>
          <a href="javascript:;" class="btn-submit" @click="gameBookClick()"><span class="light-effect"><i
                class="effect"></i></span></a>
        </div>
      </section>

      <!-- page4 -->
      <section class="page page4">
        <div class="lottery-box">
          <div class="lottery">
            <div v-for="(i, index) of 5" :key="index">
              <p v-if="index === lotteryActive" :class="`l${index + 1}`"></p>
            </div>
          </div>
          <a href="javascript:;" @click="statistics('simple_go_lougne', 'simple_go_lougne', 'https://game.naver.com/lounge/samgukji_origin2/home')" class="btn-lottery"></a>
        </div>
      </section>
    </section>

    <div v-if="showDialog.success === true" class="popup-box popup-success">
      <div class="inner">
        <a href="javascript:;" class="btn-close" @click="showDialog.success = false"></a>
        <a href="https://game.naver.com/lounge/samgukji_origin2/home" class="btn-link"></a>
      </div>
    </div>
    
    <div v-if="showDialog.privacy === true" class="popup-box popup-privacy">
      <div class="inner">
        <a href="javascript:;" class="btn-close" @click="showDialog.privacy = false"></a>
        <div class="privacy">
          <h3>개인정보 수집 및 이용 안내</h3>
          <p>&nbsp;</p>
          <p>GURU GAMES CO., LIMITED는 &lt;삼국지 오리진2: 적벽대전&gt; 게임 정보 및 사전예약 이벤트 안내를 위해 다음과 같이 개인정보를 수집 및 이용하고 있습니다.</p>
          <p>귀하는 개인정보 수집 및 이용에 동의하지 않을 수 있으며 거부 시 사전예약 이벤트에 참여하실 수 없습니다.</p>
          <p>※ 개인정보 수집 및 이용 목적 : 사전예약 이벤트 당첨자 안내 및 게임 관련 소식 전달</p>
          <p>※ 수집하는 개인정보 항목 : 휴대폰 번호</p>
          <p>※ 개인정보 보유 및 이용기간 : 수집일로부터 1년 </p>
        </div>
      </div>
    </div>
    
    <div v-if="showDialog.alert === true" class="popup-box popup-alert">
      <div class="inner">
        <a href="javascript:;" class="btn-close" @click="showDialog.alert = false"></a>
        <div class="text flex justify-center items-center">
          <div>{{ showDialog.alertMsg }}</div>
        </div>
      </div>
    </div>

    <div v-if="showDialog.again === true" class="popup-box popup-again">
      <div class="inner">
        <a href="javascript:;" class="btn-close" @click="showDialog.again = false"></a>
        <div class="text flex-col justify-center items-center">
          <div>안녕하세요, 주공님. 해당 번호는 이미 사전예약 완료된 번호입니다. 공식 라운지에서 다양한 사전예약 이벤트가 진행되고 있으니 지금 바로 참여하시고 풍성한 보상들 놓치지 마세요!</div>
          <a href="https://game.naver.com/lounge/samgukji_origin2/home" class="btn-link"></a>
        </div>
      </div>
    </div>

    <footer v-show="isFirstPage" class="footer">
      <div class="swiper sideSwiper">
        <div class="swiper-wrapper">
          <div class="swiper-slide ft1">
            <img src="../../assets/images/mobile/bottom_bg1.png" alt="">
          </div>
          <div class="swiper-slide ft2">
            <img src="../../assets/images/mobile/bottom_bg2.png" alt="">
          </div>
        </div>
      </div>
      <a href="javascript:;" @click="clickBottomBtn" :class="`btn${ios ? ' ios' : ' gp'}`"></a>
    </footer>
  </article>
</template>

<script src="../../../public/assets/swiper-bundle.min.js"></script>

<script>
  import { gameBook, showGameBookCount } from "@/api/api";
  export default {
    name: "mobile",
    data() {
      return {
        sideSwiper: null,
        shopsSwiper: null,
        menuIndex: 0,
        navs: [{
          title: "홈페이지",
        },
        {
          title: "사전예약",
        },
        {
          title: "천하제'1' 이벤트",
        },
        {
          title: "예약 인증 이벤트",
        },
        {
          title: "게임 소개",
        }],
        formData: {
          phone: '',
          os: '',
          source: this.$route.query.utm_source,
          medium: this.$route.query.utm_medium,
        },
        firstClick: true, //第一次关闭预约弹窗
        percent: 0,
        registNumbers: 0,
        hasChecked: false,
        ios: true,
        showDialog: {
          login: true,
          success: false,
          rules: false,
          video: false,
          alert: false,
          again: false, // "欢迎回来"弹窗
          menu: false,
          privacy: false,
          alertMsg: ''
        },
        isBooking: false,
        isFirstPage: true,
        lotteryActive: 0,
        style: ''
      };
    },
    created() {
      fbq('init', '1519159875489105');
      fbq('track', 'PageView');

      ttq.load('CJNA513C77U2Q32C7R4G');
      ttq.page();

      this.statistics('simple_page_view', 'simple_page_view', '')

      let ww = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
      if(ww > 750){
        document.querySelector('html').setAttribute('style', 'font-size: 1px;')
      }

      this.showBookCount()
      this.formData.phone = this.fetch('origin2_pre_phone');
      this.formData.os = this.fetch('origin2_pre_os');
      if(this.isIOS()) {
        this.ios = true
      } else {
        this.ios = false
      }
      if(this.formData.phone){
        this.hasChecked = true
        this.showDialog.login = false
      } else {
        this.formData.os = this.ios ? 'ios' : 'android'
      }
    },
    mounted() {
      this.activeLottery();
      this.swiperFunc();
      this.fitScreen();
    },
    methods: {
      statistics(name, label, url, type) {
        gtag('event', name, {'event_label': label});
        // 新开链接跳转
        if (url) {
          window.open(url);
        }
      },
      fitScreen() {
        const fit = window.innerWidth / window.innerHeight
        if(fit > 2/3) {
          this.style = `-webkit-transform: scale(${fit});transform: scale(${fit});transform-origin: bottom;`
        }
      },
      handleInput (event) {
        this.formData.phone = this.formData.phone.replace(/^(0+)|[^\d]+/g,'')   // 正整数
      },
      clickBottomBtn() {
        if (this.ios) {
          this.statistics('simple_go_apple', 'simple_go_apple', 'https://apps.apple.com/kr/app/id6447394503')
        } else {
          this.statistics('simple_go_gp', 'simple_go_gp', 'https://play.google.com/store/apps/details?id=com.guru.jpsgz.kr')
        }
      },
      closeLogin(){
        this.showDialog.login = false
        if (this.firstClick && this.formData.phone === '') {
          setTimeout(() => {
            this.showDialog.login = true
          }, 6000);
          this.firstClick = false
        }
      },
      isIOS() {
        const u = navigator.userAgent;
        return !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      },
      //邮箱预约
      gameBookClick() {
        if (this.isBooking) return;
        this.isBooking = true;
        setTimeout(() => {
          this.isBooking = false;
        }, 1000);
        if (!this.formData.os) {
          this.alert("휴대폰 OS 버전을 선택해 주세요. ");
          return;
        }
        if (!this.formData.phone) {
          this.alert("잘 못된 번호입니다. 확인 후 다시 시도해 주세요. ");
          return;
        }
        if (!this.validateTel(this.formData.phone)) {
          this.alert("잘 못된 번호입니다. 확인 후 다시 시도해 주세요. ");
          return;
        }
        if (this.hasChecked === false) {
          this.alert("개인정보 수집 및 이용/SMS 수신에 동의해 주세요.");
          return;
        }

        this.statistics('simple_complete_regis', 'simple_complete_regis', '');

        gameBook(this.formData).then((data) => {
          if (data.code === 0) {
            this.registNumbers = this.addCommasToNumber(data.num);
            this.percent = (data.num > 600000 ? 100 : data.num / 600000 * 100) + '%';
            this.showDialog.login = false;
            this.showDialog.success = true;
            this.save('origin2_pre_phone', this.formData.phone);
            this.save('origin2_pre_os', this.formData.os);

            fbq('track','CompleteRegistration');
            ttq.track('CompleteRegistration');
          } else if (data.code === 104) { //再次回来
            this.showDialog.login = false;
            this.showDialog.again = true
          } else {
            this.alert(data.message);
          }
        });
      },
      showBookCount() {
        showGameBookCount().then((data) => {
          if (data.code === 0) {
            this.registNumbers = this.addCommasToNumber(data.num);
            this.percent = (data.num > 600000 ? 100 : data.num / 600000 * 100) + '%';
          } else {
            this.alert(data.message);
          }
        });
      },
      validateTel(phone) {
        return phone.toString().length >= 7 && phone.toString().length < 9
      },
      activeLottery() {
        let that = this
        setTimeout(() => {
          that.activeLottery();
        }, 500);
        if(that.lotteryActive === 4){
          that.lotteryActive = 0
        } else {
          that.lotteryActive = that.lotteryActive + 1
        }
      },
      alert(msg) {
        this.showDialog.alert = true;
        this.showDialog.alertMsg = '';
        this.showDialog.alertMsg = msg;
      },
      addCommasToNumber(number) {
        return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      },
      backToTop() {
        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      },
      swiperFunc () {
        this.sideSwiper = new Swiper(".sideSwiper", {
          loop: true,
          allowTouchMove: false,
          autoplay : {
            delay: 2000
          },
          speed: 700,
          effect : 'fade',
          fadeEffect: {
            crossFade: true,
          }
        });
      },
      fetch(key) {
        return window.localStorage.getItem(key) || ''
      },
      save(key, items){
        if(items){
          window.localStorage.setItem(key, items.toString())
        }
      }
    }
  };
</script>

<style lang="less" scoped>
.mobile-wrap{
  max-width: 750px;
  margin: 0 auto;
}
.btn-close {
  position: absolute;
  bottom: 60rem;
  left: 50%;
  z-index: 1002;
  width: 72rem;
  height: 72rem;
  margin-left: -36rem;
  background: url(../../assets/images/mobile/btn_close.png) no-repeat;
  background-size: 100% 100%;
}

// page1
.page {
  width: 100%;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  overflow: hidden;
}

@keyframes toDown {
  0% {
    transform: translateY(0);
  }

  50% {
    transform: translateY(10rem);
  }

  100% {
    transform: translateY(0);
  }
}

// page2
.page2 {
  height: 1264rem;
  background-image: url(../../assets/pre1/bg_01.jpg);
}

.form-box {
  width: 524rem;
  height: 926rem;
  margin-left: 114rem;
  padding-top: 730rem;

  .os-box {
    p {
      background-size: 100% 100%;
    }

    .os {
      position: relative;
      display: inline-block;
      width: 24rem;
      height: 24rem;
      margin-right: 17rem;
      border: 1rem solid #fff;

      &.active::after {
        position: absolute;
        top: 4rem;
        left: 4rem;
        z-index: 9;
        width: 12rem;
        height: 12rem;
        background-color: #fff;
        content: "";
      }
    }

    .gp {
      width: 184rem;
      height: 38rem;
      background-image: url(../../assets/images/mobile/os_gp.png);
    }

    .app {
      width: 154rem;
      height: 38rem;
      background-image: url(../../assets/images/mobile/os_ios.png);
    }
  }

  .input-box {
    position: relative;
    width: 524rem;
    margin-top: 25rem;
    margin-bottom: 25rem;
    border-bottom: 1rem solid #fff;

    span {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 1;
      width: 63rem;
      color: #fff;
      font-size: 32rem;
      font-weight: bold;
      font-family: 'SimHei';
      line-height: 50rem;
    }

    .input-txt {
      width: 100%;
      height: 50rem;
      padding-left: 63rem;
      background: transparent;
      color: #fff;
      font-size: 24rem;
      line-height: 50rem;
    }
  }

  .check-box {
    margin-bottom: 25rem;

    .check {
      position: relative;
      display: inline-block;
      width: 25rem;
      height: 25rem;
      margin-right: 12rem;
      border: 1rem solid #fff;

      &.active::after {
        position: absolute;
        top: 2rem;
        left: 2rem;
        z-index: 9;
        width: 16rem;
        height: 16rem;
        background-image: url(../../assets/images/mobile/i_checked.png);
        background-size: 100% 100%;
        content: "";
      }
    }

    .txt {
      color: #898989;
      font-size: 24rem;
      text-decoration: underline;
    }
  }

  .btn-submit {
    display: block;
    width: 600rem;
    height: 122rem;
    margin-left: -36rem;
    background-image: url(../../assets/pre1/btn_pre2.png);
    background-size: 100% 100%;
    -webkit-animation: magnify .8s linear infinite alternate;
    -moz-animation: magnify .8s linear infinite alternate;
    animation: magnify .8s linear infinite alternate;

    .light-effect {
      width: 460rem;
      height: 94rem;
      margin-left: 72rem;
      margin-top: 14rem;
      border-radius: 30rem;
    }
  }
}

.light-effect {
  position: relative;
  float: left;
  display: inline;
  overflow: hidden;

  .effect {
    position: absolute;
    top: 0;
    left: -100%;
    z-index: 2;
    width: 100%;
    height: 100%;
    background: url(../../assets/images/btn_light.png) no-repeat;
    background-size: 100%;
    transition: all 650ms;
    -webkit-animation: sg 2s linear infinite;
    -moz-animation: sg 2s linear infinite;
    -ms-animation: sg 2s linear infinite;
    animation: sg 2s linear infinite;
  }
}

@keyframes sg {
  0% {
    left: -100%;
  }

  100% {
    left: 100%;
  }
}

@-webkit-keyframes sg {
  0% {
    left: -100%;
  }

  100% {
    left: 100%;
  }
}

@-moz-keyframes sg {
  0% {
    left: -100%;
  }

  100% {
    left: 100%;
  }
}

@-o-keyframes sg {
  0% {
    left: -100%;
  }

  100% {
    left: 100%;
  }
}

@-webkit-keyframes magnify {
  0% {
    -webkit-transform: scale(0.96);
  }

  100% {
    -webkit-transform: scale(1);
  }
}

@-moz-keyframes magnify {
  0% {
    -moz-transform: scale(1);
  }

  100% {
    -moz-transform: scale(0.96);
  }
}

@keyframes magnify {
  0% {
    transform: scale(1);
  }

  100% {
    transform: scale(0.96);
  }
}

// page4
.page4 {
  height: 1264rem;
  background-image: url(../../assets/pre1/bg_02.jpg);

  .lottery-box {
    position: relative;
    width: 533rem;
    height: 539rem;
    margin-left: 105rem;
    margin-top: 542rem;

    p {
      position: absolute;
      z-index: 1;
      background-size: 100% 100%;
    }

    .l1 {
      top: 0rem;
      left: 267rem;
      width: 253rem;
      height: 274rem;
      background-image: url(../../assets/pre1/lottery_1.png);
    }

    .l2 {
      top: 190rem;
      right: 1rem;
      width: 265rem;
      height: 297rem;
      background-image: url(../../assets/pre1/lottery_2.png);
    }

    .l3 {
      left: 112rem;
      bottom: 2rem;
      width: 312rem;
      height: 265rem;
      background-image: url(../../assets/pre1/lottery_3.png);
    }

    .l4 {
      left: 1rem;
      top: 187rem;
      width: 268rem;
      height: 300rem;
      background-image: url(../../assets/pre1/lottery_4.png);
    }

    .l5 {
      left: 12rem;
      top: 0;
      width: 256rem;
      height: 274rem;
      background-image: url(../../assets/pre1/lottery_5.png);
    }

    .btn-lottery {
      position: absolute;
      top: 175rem;
      left: 170rem;
      z-index: 2;
      width: 204rem;
      height: 204rem;
      background-image: url(../../assets/pre1/btn_lottery.png);
      background-size: 100% 100%;
      animation: breath 2.5s infinite;
    }
  }
}

// 呼吸效果
@keyframes breath {
  0% {
    transform: scale(.95);
  }

  50% {
    transform: scale(1.05);
  }

  100% {
    transform: scale(.95);
  }
}

.footer {
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 100;
  width: 100%;
  height: 156rem;

  .swiper-slide {
    width: 750rem;
    height: 156rem;
    background-size: 100% 100%;
    img {
      width: 100%;
    }
  }
  .swiper-slide-active{
    opacity: 1;
  }

  .btn {
    position: absolute;
    left: 246rem;
    top: 70rem;
    z-index: 101;
    width: 156rem;
    height: 44rem;
    background-size: 100% 100%;

    &.ios {
      background-image: url(../../assets/pre1/ft_ios.png);
    }

    &.gp {
      background-image: url(../../assets/pre1/ft_gp.png);
    }
  }
}

// 弹窗
.popup-box {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 998;
  width: 100%;
  background: rgba(0, 0, 0, .8);

  .inner {
    position: absolute;
    left: 50%;
    top: 50%;
    z-index: 999;
    width: 666rem;
    margin-left: -333rem;
    background-repeat: no-repeat;
    background-size: 100% auto;
  }

  .btn-close {
    top: -112rem;
    left: 600rem;
    z-index: 1000;
    margin-left: 0;
  }

  &.popup-success {
    .inner {
      height: 550rem;
      margin-top: -275rem;
      background-image: url(../../assets/images/mobile/pop_suc.jpg);
      background-size: 100% 100%;
    }

    .btn-link {
      display: block;
      width: 450rem;
      height: 96rem;
      margin-left: 110rem;
      margin-top: 110rem;
      background-image: url(../../assets/images/mobile/btn_lounge.png);
      background-size: 100% 100%;
    }
  }

  &.popup-rules, &.popup-privacy {
    .inner {
      height: 550rem;
      margin-top: -275rem;
      background-image: url(../../assets/images/mobile/pop_large.jpg);
      background-size: 100% 100%;
    }

    .rules, .privacy {
      padding: 30rem 30rem;
      color: #fff;
      font-size: 26rem;

      h3 {
        text-align: center;
        font-weight: bold;
        font-size: 30rem;
      }
    }
  }

  &.popup-again {
    .inner {
      height: 320rem;
      margin-top: -160rem;
      background-image: url(../../assets/images/mobile/pop_s.jpg);
      background-size: 100% 100%;
      color: #fff;
      font-size: 26rem;
    }

    .text {
      height: 100%;
      padding: 0 30rem;
    }
    .btn-link {
      display: block;
      width: 450rem;
      height: 96rem;
      background-image: url(../../assets/images/mobile/btn_lounge.png);
      background-size: 100% 100%;
      transform: scale(0.8);
    }
  }

  &.popup-alert {
    .inner {
      height: 266rem;
      margin-top: -133rem;
      background-image: url(../../assets/images/mobile/pop_s.jpg);
      background-size: 100% 100%;
      color: #fff;
      font-size: 26rem;
    }

    .text {
      height: 100%;
      padding: 0 30rem;
    }
  }
}
@media screen and (min-width: 750px){
  .footer {
    left: 50%;
    transform: translateX(-50%);
    max-width: 750px;
  }
}
</style>
 